// assets/montario-share-submit.js
(() => {
  if (window.__montarioShareBound) return;
  window.__montarioShareBound = true;

  const LOG = (...a) => console.log("[MONTARIO]", ...a);
  const ERR = (...a) => console.error("[MONTARIO]", ...a);
  const isValidEmail = (val) => !!(val && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val.trim()));
  const getCartShareIdFromUrl = (url) => {
    if (!url) return '';

    if (window.MontarioCartShare?.getIdFromUrl) {
      return window.MontarioCartShare.getIdFromUrl(url);
    }

    try {
      const parsedUrl = new URL(url, window.location.origin);
      const match = parsedUrl.pathname.match(/\/s\/([^/]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch {
      const match = String(url).match(/\/s\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    }
  };
  const stripCartShareNotes = (note) => {
    if (window.MontarioCartShare?.stripCartShareNotes) return window.MontarioCartShare.stripCartShareNotes(note);

    return String(note || '')
      .split(/\r?\n/)
      .filter(line => !line.trim().startsWith('Cart Share:'))
      .join('\n')
      .trim();
  };
  const makeFallbackShareId = () => Math.random().toString(36).slice(2, 8);
  const createCurrentCartShareLink = async (cart) => {
    if (window.MontarioCartShare?.createShareLink) {
      return window.MontarioCartShare.createShareLink({ forceNew: true, cart });
    }

    return '';
  };

  const getCartShareId = () => {
    const shareLinkId = getCartShareIdFromUrl(document.getElementById('shareLink')?.value);
    if (shareLinkId) {
      window.MONTARIO_CART_SHARE_ID = shareLinkId;
      try { sessionStorage.setItem('montario_cart_share_id', shareLinkId); } catch { /* ignore */ }
      return shareLinkId;
    }

    if (window.MontarioCartShare?.getOrCreateId) return window.MontarioCartShare.getOrCreateId();
    if (window.MONTARIO_CART_SHARE_ID) return window.MONTARIO_CART_SHARE_ID;

    try {
      const stored = sessionStorage.getItem('montario_cart_share_id');
      if (stored) {
        window.MONTARIO_CART_SHARE_ID = stored;
        return stored;
      }
    } catch { /* ignore */ }

    const id = makeFallbackShareId();
    window.MONTARIO_CART_SHARE_ID = id;
    try { sessionStorage.setItem('montario_cart_share_id', id); } catch { /* ignore */ }
    return id;
  };

  document.addEventListener("DOMContentLoaded", () => {
    const dialog   = document.getElementById("cartShareDialog");
    const openBtn  = document.getElementById("cartShareOpen");
    const closeBtn = dialog?.querySelector(".cs-close");

    const formView    = document.getElementById("shareFormView");
    const confirmView = document.getElementById("shareConfirmView");
    const form        = document.getElementById("shareRequestForm");
    const okEl        = document.getElementById("rq_success");
    const erEl        = document.getElementById("rq_error");

    const showEl = (el) => { if (!el) return; el.classList.remove("cs-hidden"); el.removeAttribute("hidden"); };
    const hideEl = (el) => { if (!el) return; el.classList.add("cs-hidden"); el.setAttribute("hidden", ""); };

    const showFormView = () => {
      showEl(formView);
      hideEl(confirmView);
      if (okEl) { okEl.textContent = ""; hideEl(okEl); }
      if (erEl) { erEl.textContent = ""; hideEl(erEl); }
    };
    const showConfirmView = () => {
      hideEl(formView);
      showEl(confirmView);
      document.getElementById("cs-confirm-close")?.focus?.();
    };

    // Öffnen/Schließen des Modals
    openBtn?.addEventListener("click", () => { showFormView(); dialog?.showModal?.(); });
    closeBtn?.addEventListener("click", () => dialog?.close?.());
    dialog?.addEventListener("keydown", (ev) => { if (ev.key === "Escape") dialog?.close?.(); });
    dialog?.addEventListener("click", (e) => { if (e.target === dialog) dialog?.close?.(); });
    dialog?.addEventListener("close", showFormView);

    // Formular ein-/ausklappen (nur UI)
    document.getElementById("shareWithMontario")?.addEventListener("click", () => { showEl(form); });
    document.getElementById("rq_back")?.addEventListener("click", () => { hideEl(form); });

    if (!form) return;
    if (form.dataset.bound) return;
    form.dataset.bound = "1";

    // Endpoint (Mechanic Webhook)
    const endpoint = (typeof window !== "undefined" && window.MONTARIO_WEBHOOK)
      ? window.MONTARIO_WEBHOOK
      : "https://webhooks.mechanic.dev/DEINE-WEBHOOK-ID";

    const showStatus = (ok, msg) => {
      if (ok) {
        okEl?.classList.remove("cs-hidden");
        erEl?.classList.add("cs-hidden");
        if (okEl) okEl.textContent = msg;
      } else {
        erEl?.classList.remove("cs-hidden");
        okEl?.classList.add("cs-hidden");
        if (erEl) erEl.textContent = msg;
      }
    };

    // Live-Mailcheck
    const emailInput = document.getElementById("rq_email");
    emailInput?.addEventListener("input", () => {
      const v = emailInput.value.trim();
      if (!isValidEmail(v)) emailInput.setCustomValidity("Bitte eine gültige E-Mail-Adresse eingeben.");
      else emailInput.setCustomValidity("");
      emailInput.reportValidity();
    });

    // leichte Submit-Rate-Limits
    const startedAt = Date.now();
    let lastSubmitAt = 0;
    form.addEventListener("submit", (e) => {
      if (Date.now() - startedAt < 800) { e.preventDefault(); showStatus(false, "Bitte kurz warten …"); }
      if (Date.now() - lastSubmitAt < 4000) { e.preventDefault(); showStatus(false, "Schon gesendet – bitte kurz warten."); }
    }, { capture: true });

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      e.stopPropagation();
      lastSubmitAt = Date.now();

      // Pflicht
      const firstName = (document.getElementById("rq_first_name")?.value || "").trim();
      const lastName  = (document.getElementById("rq_last_name")?.value || "").trim();
      const email     = (document.getElementById("rq_email")?.value || "").trim();
      const consent   = !!document.getElementById("rq_consent")?.checked;

      // Optional
      const phone     = (document.getElementById("rq_phone")?.value || "").trim();
      const address1  = (document.getElementById("rq_address1")?.value || "").trim();
      const zip       = (document.getElementById("rq_zip")?.value || "").trim();
      const city      = (document.getElementById("rq_city")?.value || "").trim();
      const country   = (document.getElementById("rq_country")?.value || "DE").toUpperCase();
      const message   = (document.getElementById("rq_message")?.value || "").trim();

      if (!firstName || !lastName) { showStatus(false, "Bitte Vor- und Nachname ausfüllen."); return; }
      if (!email || !isValidEmail(email)) { showStatus(false, "Bitte eine gültige E-Mail-Adresse eingeben."); return; }
      if (!consent) { showStatus(false, "Bitte Datenschutz-Einwilligung aktivieren."); return; }

      const submitBtn = form.querySelector('button[type="submit"]');
      submitBtn?.setAttribute("disabled", "disabled");

      // Warenkorb laden
      let cart;
      try {
        cart = await window.MontarioDelivery.prepareSharedCart();
      } catch (err) {
        ERR("cart load failed", err);
        showStatus(false, "Warenkorb konnte nicht geladen werden.");
        submitBtn?.removeAttribute("disabled");
        return;
      }

      let cartShareUrl = '';
      try {
        cartShareUrl = await createCurrentCartShareLink(cart);
      } catch (err) {
        ERR('cart share link failed', err);
        showStatus(false, 'Der Warenkorb-Link konnte nicht erstellt werden. Bitte erneut versuchen.');
        submitBtn?.removeAttribute('disabled');
        return;
      }

      const cartShareId = getCartShareIdFromUrl(cartShareUrl) || getCartShareId();
      if (!cartShareUrl) cartShareUrl = `${window.location.origin}/s/${cartShareId}`;

      // Payload fuer Mechanic-Webhook - Adresse/Telefon optional
      const payload = {
        source: "montario-share",
        cart_share_id: cartShareId,
        cartShareId: cartShareId,
        share_url: cartShareUrl,
        nonce: cartShareId,
        customer: {
          email,
          phone,
          first_name: firstName,
          last_name:  lastName,
          message,
          agree: true
        },
        address: {
          firstName: firstName,
          lastName:  lastName,
          address1:  address1,
          address2:  "", // Nachricht spiegelt der Server in shippingAddress.address2
          zip,
          city,
          countryCode: country
        },
        cart: {
          delivery_schema: 2,
          delivery: cart.delivery,
          attributes: cart.attributes,
          note: stripCartShareNotes(cart?.note || ""),
          items: (cart?.items || []).map(i => ({
            variant_id: i.variant_id,
            quantity:   i.quantity,
            properties: i.properties || null
          }))
        }
      };

      try {
        const resp = await fetch(endpoint, {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(payload)
        });

        if (resp.status === 204) {
          form.reset();
          hideEl(okEl); hideEl(erEl);
          showConfirmView();
        } else {
          const txt = await resp.text().catch(() => "");
          ERR("unexpected webhook status", resp.status, txt);
          showStatus(false, `Unerwartete Antwort vom Server (HTTP ${resp.status}).`);
        }
      } catch (err) {
        ERR("submit failed", err);
        showStatus(false, "Die Anfrage konnte nicht gesendet werden.");
      } finally {
        submitBtn?.removeAttribute("disabled");
      }
    });

    // Bestätigungs-View schließen
    document.getElementById("cs-confirm-close")?.addEventListener("click", () => dialog?.close?.());
  });
})();
